export const LAYERS = [
    { id: "relationellt", label: "Relationellt", color: "#38BDF8" },
    { id: "strukturellt", label: "Strukturellt", color: "#818CF8" },
    { id: "systemiskt", label: "Systemiskt", color: "#34D399" },
    { id: "digitalt", label: "Digitalt", color: "#F472B6" },
    { id: "samhalleligt", label: "Samhälleligt", color: "#FBBF24" },
];

export const DAMM = {
    fordrojning: { label: "Fördröjning", color: "#F59E0B" },
    forvridning: { label: "Förvrängning", color: "#A855F7" },
    blockering: { label: "Blockering", color: "#EF4444" },
    overbelastning: { label: "Överbelastning", color: "#F97316" },
};

export const NODE_TYPES = {
    avdelning: { label: "Avdelning", color: "#38BDF8" },
    uppgift: { label: "Uppgift", color: "#34D399" },
    syfte: { label: "Syfte", color: "#FBBF24" },
    system: { label: "System", color: "#F472B6" },
    roll: { label: "Roll", color: "#2DD4BF" },
    dokument: { label: "Dokument", color: "#A78BFA" },
    vision: { label: "Vision", color: "#FDE047" },
    malbild: { label: "Målbild", color: "#FB923C" },
    strategi: { label: "Strategi", color: "#818CF8" },
};

export const FLODESSTATUS = {
    nar_fram: { label: "Når fram", color: "#38BDF8" },
    forandras: { label: "Förändras under vägen", color: "#F59E0B" },
    nar_inte_fram: { label: "Når inte fram", color: "#EF4444" },
};

export function rollStale(reviderad) {
    if (!reviderad) return true;
    const m = /^(\d{4})-(\d{2})/.exec(reviderad);
    if (!m) return true;
    const now = new Date();
    const months = (now.getFullYear() - Number(m[1])) * 12 + (now.getMonth() + 1 - Number(m[2]));
    return months > 12;
}

export function dammInfo(b) {
    if (b.typ && DAMM[b.typ]) return DAMM[b.typ];
    return { label: b.custom_typ || b.typ || "Egen typ", color: "#94A3B8" };
}

export const SOURCE_TYPES = [
    { id: "intervju", label: "Intervju" },
    { id: "observation", label: "Observation" },
    { id: "dokument", label: "Dokument" },
    { id: "mote", label: "Möte" },
    { id: "enkat", label: "Enkät" },
];

export const BUOY_STATUS = {
    placerad: { label: "Placerad", color: "#10B981" },
    vantar_granskning: { label: "Väntar på granskning", color: "#F59E0B" },
    analyserad: { label: "Analyserad", color: "#38BDF8" },
};

export const DATAFORFRAGAN_TYPER = {
    sjukstatistik: { label: "Sjukstatistik & frånvaro", hint: "Endast aggregerad nivå – t.ex. sjukfrånvaro i % per avdelning/månad. Aldrig individnivå." },
    arendestatistik: { label: "Ärendestatistik & ledtider", hint: "Handläggningstider, volymer och kölängder per process/steg." },
    systemanvandning: { label: "Systemanvändning & licenser", hint: "Inloggningar, aktiv användning och licensutnyttjande per system." },
    puls: { label: "Enkäter & pulsmätningar", hint: "Aggregerade enkätresultat eller pulsmätningar." },
};
